<template>
    <section>
        <sau-template :retrieved="checked">
            <!-- Fetching Placeholder -->
            <template slot="message">Fetching Documents</template>
            <!-- Data -->
            <template slot="data">
                <table
                    v-if="Object.keys(documents).length > 0"
                    id="data-table-documents"
                    class="table table-hover data-table"
                    data-search="Search"
                    cellspacing="0"
                    width="100%"
                    data-sort='[4, "desc"]'
                >
                    <thead class="d-none">
                        <tr>
                            <th></th>
                            <th class="noshow">Document Type</th>
                            <th class="noshow">Name</th>
                            <th class="noshow">Size</th>
                            <th class="noshow">Date</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(doc, index) in documents" :key="index">
                            <td>
                                <a :href="downloadDocumentLink(doc.id)">
                                    <div class="d-flex product-list">
                                        <div class="text-center p-2">
                                            <i class="product-icons pr-6 pt-2 fas fa-file my-4" aria-hidden="true"></i>
                                        </div>
                                        <div class="p-2">
                                            <p class="product-name">{{ doc.document_type.name }}</p>
                                            <p class="product-desc">
                                                <span class="sau-font-bold">Name:</span>
                                                <span>{{ doc.name }}</span>
                                            </p>
                                            <p class="product-desc">
                                                <span class="sau-font-bold">Size:</span>
                                                <span>{{ Math.round(doc.size / 1000, 2) }}kb</span>
                                            </p>
                                            <p class="product-desc">
                                                <span class="sau-font-bold">Date:</span>
                                                <span>{{ doc.date | moment('DD/MM/YYYY') }}</span>
                                            </p>
                                        </div>
                                    </div>
                                </a>
                            </td>

                            <td>{{ doc.document_type.name }}</td>
                            <td>{{ doc.name }}</td>
                            <td>{{ Math.round(doc.size / 1000, 2) }}kb</td>
                            <td>{{ doc.date }}</td>
                        </tr>
                    </tbody>
                </table>

                <div v-else>
                    <sau-apiro-response type="message" support="true">
                        <template slot="message">Looks like you don't have any documents.</template>
                        <template slot="details">
                            <p>If you would like to know how to get access to documents, please contact our Support Team.</p>
                        </template>
                    </sau-apiro-response>
                </div>
            </template>
        </sau-template>
    </section>
</template>

<script>
import jsFunctions from '@js/store/jqueryFunctions';
export default {
    mixins: [jsFunctions],
    data() {
        return {
            documents: [],
            checked: false
        };
    },
    computed: {},
    mounted() {
        this.getAccountDocuments()
            .then(response => {
                this.documents = response.data;
                this.checked = true;
                if (this.documents) {
                    this.$nextTick(() => {
                        this.initializeDataTables();
                    });
                }
            })
            .catch(error => {
                this.checked = true;
            });
    }
};
</script>
<style>
#data-table-documents a {
    color: #666;
    text-decoration: none;
}
</style>
